export default function InputComponent({ children, title }) {
  return (
    <label className=" label-in">
      {" "}
      <span className=" d-block">{title}</span>
      {children}
    </label>
  );
}
